
export class Buffer {
  buffer: number[];
  constructor() {
    this.buffer = [];
  }
  get data() {
    return this.buffer;
  }
  get length() {
    return this.buffer.length;
  }
  writeInt32(value: number) {
    this.buffer.push((value >>> 24) & 0xff);
    this.buffer.push((value >>> 16) & 0xff);
    this.buffer.push((value >>> 8) & 0xff);
    this.buffer.push(value & 0xff);
  }
  writeInt16(value: number) {
    this.buffer.push((value >>> 8) & 0xff);
    this.buffer.push(value & 0xff);
  }
  writeByte(value: number) {
    this.buffer.push(value & 0xff);
  }
  writeBytes(bytes: Uint8Array) {
    for (let i = 0; i < bytes.length; i++) {
      this.buffer.push(bytes[i]);
    }
  }
  // writeString(str: string) {
  //   const bytes = new TextEncoder().encode(str);
  //   this.writeBytes(bytes);
  // }
}

// 将 32 位无符号整数写入 Uint8Array 中，按照 offset 写入
export function writUint32(data: Uint8Array, value: number, offset: number) {
  data[offset] = (value >>> 24) & 0xff;
  data[offset + 1] = (value >>> 16) & 0xff;
  data[offset + 2] = (value >>> 8) & 0xff;
  data[offset + 3] = value & 0xff;
}

// 从 Uint8Array 中按照 offset 读取 32 位无符号整数
export function readUint32(data: Uint8Array, offset: number) {
  return (data[offset] << 24) | (data[offset + 1] << 16) | (data[offset + 2] << 8) | data[offset + 3];
}

export function readUint16(data: Uint8Array, offset: number) {
  return (data[offset] << 8) | data[offset + 1];
}

export function readUint8(data: Uint8Array, offset: number) {
  return data[offset];
}

export function readString(data: Uint8Array, offset: number, length: number) {
  return (new TextDecoder).decode(readBytes(data, offset, length));
}

export function readBytes(data: Uint8Array, offset: number, length: number) {
  return data.slice(offset, offset + length);
}
